import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from '@components/modal/modal.component';
import { ModalActionsService } from '@components/modal/services/modal-actions.service';

@Component({
  selector: 'iren-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss']
})
export class ModalErrorComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {

  }

  ngOnInit(): void {
  }

  closeModal() {
    this.dialogRef.close();
  }

}
